export const headerLine = (count, groupName = '') => {
  const generateHeaders = (count, groupName) => {
    let headers = `<div class="storeeel-group-name">${groupName}</div>`;
    for (let i = 0; i < count; i++) {
      headers += `<div class="storeeel-movie-select_banner" data-index="${i}"></div>`;
    }

    const isMobile = typeof window !== 'undefined' && window.storeeelItems?.isMobile;
    const widthValue = isMobile ? '92%' : '80%';
    const bannerWidth = isMobile ? '100%' : `calc(100% / ${count})`;

    const headerTop   = isMobile ? '16px' : '-20px';
    const groupStyles = isMobile
      ? 'position: fixed; top: 8px; left: 1%; font-size: 14px;'
      : 'position: absolute; top: -35px; left: 4px; font-size: 18px;';

    headers += `
      <style>
        .storeeel-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 100;
          top: ${headerTop};
          width: ${widthValue};
          left: 50%;
          transform: translateX(-50%);
          position: ${isMobile ? 'fixed' : 'fixed'};
        }


        .storeeel-group-name {
          ${groupStyles}
          font-weight: bold;
          color: white;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
        }

        .storeeel-movie-select_banner {
          width: ${bannerWidth};
          height: 3px;
          background-color: rgba(255, 255, 255, 0.2);
          margin: 0 3px;
          position: relative;
          overflow: hidden;
        }

        .storeeel-movie-select_banner::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          background-color: white;
          width: 0%;
          animation: none;
        }

        .storeeel-movie-select_banner.active::before {
          animation: progressBarAnimation var(--duration, 3s) linear forwards;
        }

        .storeeel-movie-select_banner.completed::before {
          width: 100%;
          background-color: white;
        }

        @keyframes progressBarAnimation {
          0% { width: 0%; }
          100% { width: 100%; }
        }
      </style>
    `;
    return headers;
  };

  const headerLineHTML = `<div class="storeeel-header">${generateHeaders(count, groupName)}</div>`;
  return headerLineHTML;
};
